import React, { useEffect, useState, useMemo } from "react";
import PilotageLayout from "./PilotageLayout";
import { loadOrders, formatOrderDate, formatOrderAmount } from "../../../data/orders";
import { getOrderFinancials } from "../../../data/payments";

const PilotageEncours = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    let isMounted = true;
    loadOrders().then((loadedOrders) => {
      if (!isMounted) return;
      setOrders(loadedOrders || []);
      setLoaderStatus(false);
    });
    return () => { isMounted = false; };
  }, []);

  const pendingOrders = useMemo(() => {
    return orders.map(order => {
      const fin = getOrderFinancials(order);
      return { ...order, financials: fin };
    }).filter(o => o.financials.remainingAmount > 0)
      .sort((a, b) => new Date(b.date) - new Date(a.date));
  }, [orders]);

  if (loaderStatus) {
    return (
      <PilotageLayout>
        <div className="p-6">Chargement des encours...</div>
      </PilotageLayout>
    );
  }

  return (
    <PilotageLayout>
      <div className="card border-0 shadow-sm rounded-3">
        <div className="card-header bg-white border-bottom p-4">
          <h4 className="mb-0 fw-bold text-dark">Paiements Différés (Encours)</h4>
          <p className="text-muted mb-0 small mt-1">
            Liste des commandes avec un reste à payer.
          </p>
        </div>

        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="table-light text-secondary text-uppercase" style={{ fontSize: "0.75rem" }}>
                <tr>
                  <th className="ps-4">Date</th>
                  <th>Commande</th>
                  <th>Client</th>
                  <th className="text-end">Total TTC</th>
                  <th className="text-end">Payé</th>
                  <th className="text-end pe-4 text-danger">Reste à payer</th>
                </tr>
              </thead>
              <tbody style={{ fontSize: "0.85rem" }}>
                {pendingOrders.map(order => (
                  <tr key={order.id}>
                    <td className="ps-4 text-muted">{formatOrderDate(order.date)}</td>
                    <td className="fw-medium">
                      <a href="#" className="text-decoration-none">#{order.id.slice(0, 8).toUpperCase()}</a>
                    </td>
                    <td>{order.customerType === 'PRO' ? (order.customerName || 'Client Pro') : 'Client Standard'}</td>
                    <td className="text-end">{formatOrderAmount(order.financials.totalAmount)}</td>
                    <td className="text-end text-success">{formatOrderAmount(order.financials.paidAmount)}</td>
                    <td className="text-end pe-4 fw-bold text-danger">{formatOrderAmount(order.financials.remainingAmount)}</td>
                  </tr>
                ))}
                {pendingOrders.length === 0 && (
                  <tr>
                    <td colSpan="6" className="text-center py-5 text-muted">
                      <i className="fas fa-check-circle fs-2 text-success mb-3 d-block"></i>
                      Aucun encours. Toutes les commandes sont réglées.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </PilotageLayout>
  );
};

export default PilotageEncours;
